export default __webpack_public_path__ + "media/images/icons/arrow-blue-prev-eb50b0441617a41d700693b88eda27db.png";